<template>
    <div class="permission-list-page">
        <!-- 角色 -->
        <div class="permission-list-role">
            <div class="flex permission-list-title justify-between items-center">
                <div class="role-title-text">{{ $t('Staff.role') }}</div>
                <div class="flex items-center role-iconfont-color">
                    <el-tooltip
                        effect="dark"
                        :content="$t('tooltip.add')"
                        placement="bottom">
                        <div
                            @click="handleModify('add')"
                            class="iconfont role-icon-bigsize
                            icon-fitness-tianjiawenjian">
                        </div>
                    </el-tooltip>
                    <el-tooltip
                        v-if="!isSystemRole"
                        effect="dark"
                        :content="$t('tooltip.edit')"
                        placement="bottom">
                        <div
                            @click="handleModify('edit')"
                            class="iconfont role-icon-size
                            icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy
                            mr-5 ml-5">
                        </div>
                    </el-tooltip>
                    <el-tooltip
                        v-if="!isSystemRole"
                        effect="dark"
                        :content="$t('tooltip.delete')"
                        placement="bottom">
                        <div
                            @click="handleDelete()"
                            class="iconfont role-icon-size icon-fitness-shanchu">
                        </div>
                    </el-tooltip>
                </div>
            </div>
            <div class="permission-list-content">
                <div
                    @click="clickRole(item)"
                    :class="{'permission-clicked': item.id === roleId}"
                    class="permission-role-single cursor-pointer"
                    v-for="(item, index) in roles"
                    :key="index">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <!-- 权限模块 -->
        <div class="permission-list-module mt-10">
            <table class="w-full" cellspacing="0" cellpadding="0">
                <thead>
                    <tr align="left" class="permission-th-tr">
                        <th width="33.3%">{{ $t('Staff.First_level_module') }}</th>
                        <th width="33.3%">{{ $t('Staff.two_level_module') }}</th>
                        <th width="33.3%">{{ $t('Staff.Jurisdiction') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="permission-one-td">
                            <table width="100%" cellspacing="0" cellpadding="0">
                                <tbody>
                                    <tr v-for="(item, index) in TableData" :key="index">
                                        <td width="100%" class="permission-once-td">
                                            <div
                                                class="hover-blue cursor-pointer inline-block"
                                                @click="active = item.name"
                                                :class="{'fitness-blue': active === item.name}"
                                            >{{ item.name }}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td colspan="2" style="vertical-align: top;">
                            <table
                                v-for="(item, index) in TableData"
                                :key="`a-${index}`"
                                v-if="active === item.name"
                                class="w-full"
                                cellspacing="0"
                                cellpadding="0">
                                <tbody>
                                    <template v-for="(iitem) in item.subModules" >
                                        <tr
                                            :key="`${Math.random()}-${iiindex}`"
                                            v-for="(iiitem, iiindex) in iitem.permissions">
                                            <td width="50%"
                                                class="permission-second-td"
                                                :rowspan="iitem.permissions.length"
                                                v-if="!iiindex">
                                                {{ iitem.name }}
                                            </td>
                                            <td class="permission-second-td" width="50%">
                                                <el-checkbox
                                                    v-model="iiitem.enable"
                                                >{{iiitem.name}}</el-checkbox>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 保存按钮 -->
        <div class="flex justify-center mt-10 mb-10">
            <el-button
                @click="submit"
                type="primary"
            >{{ $t('Common.save') }}</el-button>
        </div>

        <!-- 弹窗 -->
        <handle-role ref="role" @fetchRole="fetchRole" />
    </div>
</template>
<script>
import { DatePicker, Radio, RadioButton, RadioGroup, Checkbox } from 'element-ui';
import handleRole from '@/components/Dialog/Staff/handleRole';

export default {
    components: {
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioButton: RadioButton,
        ElRadioGroup: RadioGroup,
        ElCheckbox: Checkbox,
        handleRole,
    },
    data() {
        return {
            roles: [],
            roleId: null,
            active: null,
            TableData: [],
            isSystemRole: true,
        };
    },
    created() {
        this.fetchRole();
    },
    methods: {
        fetchRole() {
            API.get('role/list').then(res => {
                this.roles = res;
                if (!this.roleId) this.isSystemRole = res[0].id;
                this.roleId = this.roleId || res[0].id;
                this.fetchPermission();
            });
        },
        clickRole(item) {
            this.roleId = item.id;
            this.isSystemRole = item.isSystemRole;
            this.fetchPermission();
        },
        fetchPermission() {
            API.get(`role/${this.roleId}/permissions`).then(res => {
                this.TableData = res;
                this.active = res[0].name;
            });
        },
        handleModify(type) {
            const roleId = type === 'edit' ? this.roleId : null;
            this.$refs.role.open(roleId);
        },
        handleDelete() {
            $ele.$confirm(this.$t('Staff.delete_role'), this.$t('Common.tip'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.delete(`role/${this.roleId}`).then(() => {
                    $ele.$message.success(this.$t('Successful_role_del'));
                    this.roleId = null;
                    this.fetchRole();
                });
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        submit() {
            let array = [];
            this.TableData.map(el => {
                el.subModules.map(item => {
                    item.permissions.map(res => {
                        if (res.enable) array.push(res.code);
                    });
                });
            });
            API.put(`role/${this.roleId}/permissions`, {
                permissionCodes: array,
            }).then(() => {
                $ele.$message.success('权限分配成功');
                this.fetchPermission();
                this.$store.dispatch('getMy', null, false);
            });
        },
    },
};
</script>
<style lang="scss">
.permission-list-role {
    border: 1px solid #e6e6e6;
}
.permission-list-title {
    padding: 10px 20px;
    background: #fafafa;
    border-bottom: 1px solid #e6e6e6;
    .role-iconfont-color {
        color: #697a8e;
    }
}
.role-title-text {
    font-size: 13px;
}
.role-icon-size {
    font-size: 16px;
}
.role-icon-bigsize {
    font-size: 18px;
}
.permission-list-content {
    padding: 20px;
}
.permission-role-single {
    font-size: 12px;
    display: inline-block;
    margin-right: 30px;
    margin-bottom: 10px;
    border: 1px solid #05abef;
    border-radius: 20px;
    color: #05abef;
    padding: 5px 15px;
}
.permission-clicked {
    color: #fff;
    background: #05abef;
}
.permission-th-tr {
    th {
        padding: 13px 10px;
        border: 1px solid #e6e6e6;
        border-left: none;
        background: #fafafa;
    }
    th:first-child {
        border-left: 1px solid #e6e6e6;
    }
}
.permission-one-td {
    border: 1px solid #e6e6e6;
    vertical-align: top;
    border-top: none;
}
.permission-second-td {
    border: 1px solid #e6e6e6;
    border-top: none;
    padding: 10px;
}
.permission-once-td {
    border-bottom: 1px solid #e6e6e6;
    padding: 13px 10px;
}
.permission-second-td {
    border-left: none;
}
.hover-blue {
    &:hover {
        color: #05abef;
    }
}
</style>
